import React from "react";
import PropTypes from "prop-types";

import { lighten } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import IconButton from "@mui/material/IconButton";
import SettingsIcon from "@mui/icons-material/Settings";
import Box from "@mui/material/Box";

const EnhancedTableToolbar = props => {
  const { title, rows, selected, deleteHandler, expandHandler, deleteButton, filterList, settingsCallback } = props;

  const numSelected = selected.length;
  return (
    <Toolbar
      sx={theme => ({
        pl: 2,
        pr: 1,
        ...(numSelected > 0 &&
          (theme.palette.mode === "light"
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
              }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
              })),
      })}
    >
      <Box sx={{ flex: "0 0 auto" }}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subtitle1">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="h6" id="tableTitle">
            {title}
          </Typography>
        )}
      </Box>
      <Box sx={{ flex: "1 1 100%" }} />
      <Box sx={{ color: "text.secondary" }}>
        {numSelected > 0 && deleteButton && (
          <Tooltip title="Delete">
            <IconButton
              aria-label="Delete"
              onClick={() => deleteHandler(selected.map(idx => rows.find(row => idx === row.selectIndex)))}
              size="large">
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
        <Box sx={{ display: "flex" }}>
          {settingsCallback && (
            <Tooltip title="Settings">
              <IconButton aria-label="Settings" onClick={() => settingsCallback()} size="large">
                <SettingsIcon />
              </IconButton>
            </Tooltip>
          )}
          {filterList && (
            <Tooltip title="Filter list">
              <IconButton aria-label="Filter list" onClick={() => expandHandler()} size="large">
                <FilterListIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </Box>
    </Toolbar>
  );
};

EnhancedTableToolbar.defaultProps = {
  deleteButton: true,
  settingsCallback: undefined,
};

EnhancedTableToolbar.propTypes = {
  title: PropTypes.string.isRequired,
  rows: PropTypes.array.isRequired,
  selected: PropTypes.array.isRequired,
  deleteHandler: PropTypes.func.isRequired,
  expandHandler: PropTypes.func.isRequired,
  deleteButton: PropTypes.bool,
  filterList: PropTypes.bool.isRequired,
  settingsCallback: PropTypes.func,
};

export default EnhancedTableToolbar;
